import { makeStyles } from '@material-ui/core/styles';
import TextField, { TextFieldProps } from '@material-ui/core/TextField';
import { merge } from 'lodash';
import { MID_GRAY, SILVER_CHALICE } from '../helpers/colors';

const useStyles = makeStyles(theme => ({
  disabled: {
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
    },
  },

  inputRoot: {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&$inputFocused': {
      backgroundColor: 'transparent',
    },
    '&$inputDisabled': {
      backgroundColor: 'transparent',
    },
  },
  inputFocused: {},
  inputDisabled: {},
  inputInput: {
    padding: '32px 16px 12px',
    transition: 'padding 0.1s',
    willChange: 'padding',
  },
  inputInputWithoutLabel: {
    padding: '22px 16px',
    transition: 'padding 0.1s',
    willChange: 'padding',
  },
  inputMultiline: {
    padding: '32px 16px 12px',
  },
  inputInputMultiline: {
    padding: 0,
  },
  inputAdornedStart: {
    paddingLeft: 20,
  },

  inputLabelRoot: {
    left: 4,
    color: SILVER_CHALICE,
    fontSize: '1rem',
    fontWeight: 'normal',
    whiteSpace: 'nowrap',
    '&$inputLabelFocused': {
      color: SILVER_CHALICE,
    },
  },
  inputLabelFocused: {},
  inputLabelFilled: {
    transform: 'translate(12px, 24px) scale(1)',
    '&$adornedStart': {
      transform: 'translate(7px, 24px) scale(1)',
    },
  },
  inputLabelShrink: {
    '&$inputLabelFilled': {
      transform: 'translate(12px, 16px) scale(0.75)',
      '&$adornedStart': {
        transform: 'translate(8px, 16px) scale(0.75)',
      },
    },
  },
  adornedStart: {
    left: 52,
  },

  formHelperTextRoot: {
    margin: '0 16px 12px',
  },

  selectSelect: {
    overflow: 'hidden',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectIcon: {
    color: MID_GRAY,
    paddingRight: theme.spacing(1),
  },

  menuListPadding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const BareTextField = (props: TextFieldProps) => {
  const classes = useStyles();

  const adornedStart = !!(props.InputProps && props.InputProps.startAdornment);

  const mergedProps = merge(
    {
      variant: 'filled',
      fullWidth: true,
      classes: {
        root: props.disabled ? classes.disabled : '',
      },
      InputLabelProps: {
        className: classes.inputLabelRoot,
        classes: {
          root: adornedStart ? classes.adornedStart : null,
          focused: classes.inputLabelFocused,
          filled: classes.inputLabelFilled,
          shrink: classes.inputLabelShrink,
        },
      },
      InputProps: {
        disableUnderline: true,
        classes: {
          root: classes.inputRoot,
          focused: classes.inputFocused,
          input: props.label
            ? classes.inputInput
            : classes.inputInputWithoutLabel,
          multiline: classes.inputMultiline,
          inputMultiline: classes.inputInputMultiline,
          disabled: classes.inputDisabled,
          adornedStart: classes.inputAdornedStart,
        },
      },
      FormHelperTextProps: {
        classes: {
          root: classes.formHelperTextRoot,
        },
      },
    },
    props,
  );

  return <TextField {...mergedProps} />;
};

export default BareTextField;
